













































































































import { Prop, Component, Mixins, Watch, Ref } from "vue-property-decorator";
import WithItemsMixin from "../private/WithItemsMixin";
import AbcCheckbox from "../input/AbcCheckbox.vue";
import { AbcTooltip } from "../directives/AbcTooltip";
import { AbcHeader } from "./TableInterfaces";

@Component({
    components: {
        AbcCheckbox,
    },
    directives: {
        AbcTooltip,
    },
})
export default class AbcTable extends Mixins(WithItemsMixin) {
    @Ref("table") table!: HTMLTableElement;
    @Prop({ type: Boolean }) borderLess!: boolean;
    @Prop({type: Boolean}) disableSelectOnClick!: boolean;
    @Prop({type: Boolean}) exportEnabled!: boolean;
    @Prop({ type: Boolean }) hasFooter!: boolean;
    @Prop({ type: Boolean }) hasToolbarBottom!: boolean;
    @Prop({ type: Boolean }) hasToolbarTop!: boolean;
    @Prop() headers!: AbcHeader[] | string[];
    @Prop({ type: Boolean }) hideSelectAll!: boolean;
    @Prop({ type: Boolean }) isCondensed!: boolean;
    @Prop({ type: Boolean }) noOverflow!: boolean;
    @Prop({ type: Boolean }) showSelection!: boolean;
    @Prop() sortBy!: string | undefined;
    @Prop({ type: Boolean }) sortDesc!: boolean;
    @Prop({ type: Boolean }) noAutoScroll!: boolean;

    private refSortBy = this.sortBy || null;
    private refSortDesc = this.sortDesc;

    private get computedHeaders() {
        if (!this.headers) {
            return [];
        }
        if (typeof this.headers[0] === "string") {
            const keys = Object.keys(this.items || []);
            const tempHeaders = this.headers as string[];
            return tempHeaders.map((h, i) => ({
                itemName: keys[i],
                title: h,
            }));
        }
        return this.headers;
    }

    private get sortedItems(){
        if(!this.items || this.items && this.items.length === 0){
            return [];
        }
        if(!this.refSortBy){
            return this.items;
        }
        const _sortBy = this.refSortBy;
        const tempItems = [... this.items]
        return tempItems.sort((a: any, b: any) => {
            let res = 0;
            if(!this.refSortDesc){
                if(a[_sortBy] < b[_sortBy]){
                    res = -1;
                } else if(a[_sortBy] > b[_sortBy]){
                    res = 1;
                }
            } else {
                if(b[_sortBy] < a[_sortBy]){
                    res = -1;
                } else if(a[_sortBy] > b[_sortBy]){
                    res = 1;
                }
            }
            return res;
        })
    }

    @Watch("sortedItems", {immediate: true})
    @Watch("computedHeaders", {immediate: true})
    onItemChange(){
        if(!this.exportEnabled){
            return;
        }
        const table: string[][] = [];
        requestAnimationFrame(() => {
            const rows = this.table.querySelectorAll("table tr");

            for (let i = 0; i < rows.length; i++) {
                const row: string[] = [], cols = rows[i].querySelectorAll("td, th") as NodeListOf<HTMLTableHeaderCellElement | HTMLTableDataCellElement>;

                for (let j = 0; j < cols.length; j++) {
                    if(!cols[j].classList.contains("not-exportable")){
                        row.push(cols[j].innerText);
                    }
                }

                table.push(row);
            }

            this.$emit('exportable-data', table)
        })
    }

    private onRowClick(index: number, fromCheckBox = false) {
        if (!this.items || (this.disableSelectOnClick && !fromCheckBox) || (!this.disableSelectOnClick && fromCheckBox)) {
            return;
        }
        const item = this.sortedItems[index];
        let realIndex = this.items.findIndex(i => this.isEqual(i, item))
        if (this.isItemDisabled(item)) {
            return;
        }
        if (!Array.isArray(this.selectedItem) && this.isEqual(item, this.selectedItem)) {
            realIndex = -1;
        }
        this.$emit("select", realIndex);
    }

    private onTableCheckboxClick() {
        if (!this.items) {
            return;
        }
        if (!Array.isArray(this.selectedItem)) {
            return;
        }
        let select: boolean | undefined = true;
        if (this.selectedItem && this.selectedItem.length > 0) select = undefined;
        if (this.selectedItem.length == this.items.length) select = false;
        this.$emit("selectAll", select);
    }

    private tableClass() {
        return {
            big: !this.isCondensed,
            bordered: !this.borderLess,
            "not-bordered": this.borderLess,
        };
    }

    private tableCheckboxValue(): boolean | undefined {
        if (!this.items) {
            return false;
        }
        if (Array.isArray(this.selectedItem)) {
            if (this.selectedItem.length === 0) {
                return false;
            }
            if (this.selectedItem.length === this.items.length) {
                return true;
            }
            return undefined;
        }
        return false;
    }

    private isRowSelected(item: unknown): boolean {
        const selected = Array.isArray(this.selectedItem)
            ? this.selectedItem.some((si) => this.isEqual(si, item))
            : this.isEqual(item, this.selectedItem);
        return selected;
    }

    private trClass(item: unknown) {
        const disabled = this.isItemDisabled(item);
        return {
            "text-secondary-300": disabled,
            [this.followMouse]: !!this.followMouse && !disabled,
            big: !this.isCondensed,
            selected: this.isRowSelected(item) && !disabled,
        };
    }

    private changeSort(header: AbcHeader){
        if(!header.sortable){
            return;
        }
        let sortDescUpdated = this.refSortDesc ? false : true;
        if(header.itemName != this.refSortBy){
            sortDescUpdated = false;
        }
        this.refSortBy = header.itemName || null;
        this.refSortDesc = sortDescUpdated;
        this.$emit("update:sortBy", header.itemName);
        this.$emit("update:sortDesc", sortDescUpdated);
    }
}
